import React from "react";
import classes from "../Liquidity/styles.module.css";
import { Link } from "react-router-dom";

const PageBody = () => {
  return (
    <div className={classes.market}>
      <div className={classes.hero}>
        <p className={classes.title}>Market Making</p>
        <p className={classes.message}>
          Benefit from a bespoke approach to market making.
        </p>
      </div>

      <div className={classes.contentContainer}>
        <h3 className={classes.heading}>
          <span className={classes.lg}>What is a market making solution?</span>
          <span className={classes.sm}>What is it?</span>
        </h3>

        <p className={classes.info}>
          It makes it easier for traders and investors to execute trades quickly
          and at a fair price. With advanced technology and algorithms to
          execute trades quickly and efficiently, and we provide real-time
          market data and insights to help our clients make more informed
          trading decisions.
        </p>

        <p className={classes.info}>
          We also provide one of the best spread and execution speed in the
          market, allowing clients to maximize their returns and stay ahead of
          the competition.
        </p>

        <p className={classes.info}>
          By partnering with Prime Bridge, clients can customize leverage,
          spread, and swap accordingly to your strategies.
        </p>
        <Link to={"/request-demo"}>
          <button className={classes.demoBtn}>Request a Demo</button>
        </Link>

        <div className={classes.benefitSection}>
          <h3 className={classes.heading}>
            <span className={classes.sm}>Benefits</span>

            <span className={classes.lg}>
              Benefits of our market making service
            </span>
          </h3>

          <div className={classes.benefitList}>
            <div className={classes.benefitItem}>
              <svg
                width="45"
                height="45"
                viewBox="0 0 45 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M38.8636 0H6.13636C4.5089 0 2.94809 0.646508 1.7973 1.7973C0.646508 2.94809 0 4.5089 0 6.13636V38.8636C0 40.4911 0.646508 42.0519 1.7973 43.2027C2.94809 44.3535 4.5089 45 6.13636 45H38.8636C40.4911 45 42.0519 44.3535 43.2027 43.2027C44.3535 42.0519 45 40.4911 45 38.8636V6.13636C45 4.5089 44.3535 2.94809 43.2027 1.7973C42.0519 0.646508 40.4911 0 38.8636 0ZM14.3182 40.9091H6.13636C5.59388 40.9091 5.07361 40.6936 4.69001 40.31C4.30641 39.9264 4.09091 39.4061 4.09091 38.8636V36.45C4.74683 36.6881 5.43857 36.8126 6.13636 36.8182H14.3182V40.9091ZM14.3182 32.7273H6.13636C5.59388 32.7273 5.07361 32.5118 4.69001 32.1282C4.30641 31.7446 4.09091 31.2243 4.09091 30.6818V28.2682C4.74683 28.5063 5.43857 28.6308 6.13636 28.6364H14.3182V32.7273ZM14.3182 24.5455H6.13636C5.59388 24.5455 5.07361 24.33 4.69001 23.9464C4.30641 23.5628 4.09091 23.0425 4.09091 22.5V6.13636C4.09091 5.59388 4.30641 5.07361 4.69001 4.69001C5.07361 4.30641 5.59388 4.09091 6.13636 4.09091H14.3182V24.5455ZM26.5909 40.9091H18.4091V28.6364H26.5909V40.9091ZM26.5909 24.5455H18.4091V4.09091H26.5909V24.5455ZM40.9091 38.8636C40.9091 39.4061 40.6936 39.9264 40.31 40.31C39.9264 40.6936 39.4061 40.9091 38.8636 40.9091H30.6818V36.8182H38.8636C39.5614 36.8126 40.2532 36.6881 40.9091 36.45V38.8636ZM40.9091 30.6818C40.9091 31.2243 40.6936 31.7446 40.31 32.1282C39.9264 32.5118 39.4061 32.7273 38.8636 32.7273H30.6818V28.6364H38.8636C39.5614 28.6308 40.2532 28.5063 40.9091 28.2682V30.6818ZM40.9091 22.5C40.9091 23.0425 40.6936 23.5628 40.31 23.9464C39.9264 24.33 39.4061 24.5455 38.8636 24.5455H30.6818V4.09091H38.8636C39.4061 4.09091 39.9264 4.30641 40.31 4.69001C40.6936 5.07361 40.9091 5.59388 40.9091 6.13636V22.5ZM34.7727 12.2727C34.3682 12.2727 33.9727 12.3927 33.6363 12.6174C33.3 12.8422 33.0378 13.1617 32.883 13.5354C32.7282 13.9092 32.6876 14.3205 32.7666 14.7172C32.8455 15.114 33.0403 15.4785 33.3264 15.7645C33.6124 16.0506 33.9769 16.2454 34.3737 16.3243C34.7705 16.4033 35.1817 16.3628 35.5555 16.2079C35.9292 16.0531 36.2487 15.7909 36.4735 15.4546C36.6982 15.1182 36.8182 14.7227 36.8182 14.3182C36.8182 13.7757 36.6027 13.2554 36.2191 12.8718C35.8355 12.4882 35.3152 12.2727 34.7727 12.2727ZM10.2273 16.3636C10.6318 16.3636 11.0273 16.2437 11.3637 16.0189C11.7 15.7942 11.9622 15.4747 12.117 15.1009C12.2718 14.7272 12.3123 14.3159 12.2334 13.9191C12.1545 13.5224 11.9597 13.1579 11.6736 12.8718C11.3876 12.5858 11.0231 12.391 10.6263 12.312C10.2295 12.2331 9.81827 12.2736 9.44451 12.4284C9.07075 12.5832 8.7513 12.8454 8.52654 13.1818C8.30178 13.5182 8.18182 13.9136 8.18182 14.3182C8.18182 14.8607 8.39732 15.3809 8.78092 15.7645C9.16452 16.1481 9.68478 16.3636 10.2273 16.3636Z"
                  fill="#01486D"
                />
              </svg>

              <p>Improved liquidity</p>
            </div>
            <div className={classes.benefitItem}>
              <svg
                width="29"
                height="19"
                viewBox="0 0 29 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.6295 8.42992L9.0045 4.82816C8.73146 4.55687 8.36114 4.40446 7.975 4.40446C7.58886 4.40446 7.21854 4.55687 6.9455 4.82816C6.67246 5.09945 6.51907 5.4674 6.51907 5.85106C6.51907 6.04103 6.55673 6.22914 6.62989 6.40465C6.70306 6.58016 6.8103 6.73963 6.9455 6.87396L8.1055 8.01212H2.9V2.2493C2.9 1.8672 2.74723 1.50075 2.4753 1.23057C2.20338 0.960382 1.83456 0.808594 1.45 0.808594C1.06544 0.808594 0.696623 0.960382 0.424695 1.23057C0.152767 1.50075 0 1.8672 0 2.2493V16.6563C0 17.0384 0.152767 17.4049 0.424695 17.6751C0.696623 17.9453 1.06544 18.0971 1.45 18.0971C1.83456 18.0971 2.20338 17.9453 2.4753 17.6751C2.74723 17.4049 2.9 17.0384 2.9 16.6563V10.8935H8.1055L6.9455 12.0317C6.80959 12.1656 6.70172 12.325 6.62811 12.5005C6.55449 12.6761 6.51659 12.8644 6.51659 13.0546C6.51659 13.2448 6.55449 13.4331 6.62811 13.6086C6.70172 13.7842 6.80959 13.9436 6.9455 14.0775C7.0803 14.2125 7.24067 14.3197 7.41736 14.3928C7.59406 14.466 7.78358 14.5036 7.975 14.5036C8.16642 14.5036 8.35594 14.466 8.53264 14.3928C8.70933 14.3197 8.8697 14.2125 9.0045 14.0775L12.6295 10.4757C12.7615 10.3387 12.865 10.1771 12.934 10.0003C13.079 9.64954 13.079 9.25611 12.934 8.90535C12.865 8.72851 12.7615 8.56694 12.6295 8.42992ZM27.55 0.808594C27.1654 0.808594 26.7966 0.960382 26.5247 1.23057C26.2528 1.50075 26.1 1.8672 26.1 2.2493V8.01212H20.8945L22.0545 6.87396C22.1897 6.73963 22.2969 6.58016 22.3701 6.40465C22.4433 6.22914 22.4809 6.04103 22.4809 5.85106C22.4809 5.66109 22.4433 5.47298 22.3701 5.29747C22.2969 5.12196 22.1897 4.96249 22.0545 4.82816C21.9193 4.69383 21.7588 4.58728 21.5822 4.51458C21.4055 4.44188 21.2162 4.40446 21.025 4.40446C20.8338 4.40446 20.6445 4.44188 20.4678 4.51458C20.2912 4.58728 20.1307 4.69383 19.9955 4.82816L16.3705 8.42992C16.2385 8.56694 16.135 8.72851 16.066 8.90535C15.921 9.25611 15.921 9.64954 16.066 10.0003C16.135 10.1771 16.2385 10.3387 16.3705 10.4757L19.9955 14.0775C20.1303 14.2125 20.2907 14.3197 20.4674 14.3928C20.6441 14.466 20.8336 14.5036 21.025 14.5036C21.2164 14.5036 21.4059 14.466 21.5826 14.3928C21.7593 14.3197 21.9197 14.2125 22.0545 14.0775C22.1904 13.9436 22.2983 13.7842 22.3719 13.6086C22.4455 13.4331 22.4834 13.2448 22.4834 13.0546C22.4834 12.8644 22.4455 12.6761 22.3719 12.5005C22.2983 12.325 22.1904 12.1656 22.0545 12.0317L20.8945 10.8935H26.1V16.6563C26.1 17.0384 26.2528 17.4049 26.5247 17.6751C26.7966 17.9453 27.1654 18.0971 27.55 18.0971C27.9346 18.0971 28.3034 17.9453 28.5753 17.6751C28.8472 17.4049 29 17.0384 29 16.6563V2.2493C29 1.8672 28.8472 1.50075 28.5753 1.23057C28.3034 0.960382 27.9346 0.808594 27.55 0.808594Z"
                  fill="#01486D"
                />
              </svg>

              <p>Tighter bid-ask spreads</p>
            </div>
            <div className={classes.benefitItem}>
              <svg
                width="36"
                height="45"
                viewBox="0 0 36 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M35.8157 14.8485C35.6474 14.4632 35.3741 14.1325 35.0267 13.8939C34.6794 13.6554 34.2719 13.5185 33.8504 13.4987H23.5046L26.3734 2.83578C26.4648 2.50211 26.4777 2.15196 26.4111 1.81252C26.3445 1.47309 26.2002 1.15352 25.9894 0.878652C25.7789 0.606421 25.5087 0.385804 25.1994 0.233725C24.89 0.0816463 24.5498 0.0021451 24.2048 0.00131933H8.3924C7.88242 -0.0160771 7.38155 0.138992 6.97137 0.441272C6.56118 0.743551 6.26586 1.17523 6.13348 1.666L0.0795795 24.1617C-0.011789 24.4954 -0.0246733 24.8455 0.0419281 25.185C0.10853 25.5244 0.252822 25.844 0.463595 26.1188C0.676352 26.3941 0.950225 26.6165 1.26375 26.7687C1.57728 26.9209 1.92194 26.9988 2.27073 26.9962H11.0128L6.9241 42.1583C6.79014 42.6472 6.82589 43.1668 7.02554 43.633C7.22519 44.0991 7.57705 44.4845 8.02411 44.7266C8.47117 44.9688 8.98723 45.0535 9.48866 44.967C9.9901 44.8806 10.4475 44.6281 10.7869 44.2504L35.4091 17.2555C35.7023 16.9358 35.8966 16.5387 35.9687 16.1117C36.0408 15.6847 35.9877 15.2461 35.8157 14.8485ZM13.7009 34.3747L16.1179 25.3765C16.2093 25.0428 16.2222 24.6926 16.1556 24.3532C16.089 24.0138 15.9447 23.6942 15.7339 23.4193C15.5235 23.1471 15.2532 22.9265 14.9439 22.7744C14.6345 22.6223 14.2943 22.5428 13.9493 22.542H5.27509L10.1092 4.50046H21.2457L18.3768 15.1634C18.2847 15.5032 18.274 15.8598 18.3454 16.2045C18.4169 16.5492 18.5686 16.8724 18.7883 17.1481C19.008 17.4238 19.2896 17.6443 19.6105 17.7919C19.9314 17.9395 20.2825 18.01 20.6357 17.9979H28.7001L13.7009 34.3747Z"
                  fill="#01486D"
                />
              </svg>

              <p>Real-time market insights</p>
            </div>
            <div className={classes.benefitItem}>
              <svg
                width="42"
                height="40"
                viewBox="0 0 42 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M41.9296 15.1309C41.7971 14.7483 41.5562 14.4122 41.2361 14.1635C40.916 13.9148 40.5303 13.764 40.126 13.7295L28.1932 11.9935L22.8455 1.17989C22.6738 0.826264 22.4057 0.528029 22.0719 0.319353C21.7381 0.110677 21.3521 0 20.9581 0C20.5641 0 20.1781 0.110677 19.8443 0.319353C19.5105 0.528029 19.2424 0.826264 19.0707 1.17989L13.7229 11.9725L1.79019 13.7295C1.40205 13.7845 1.03715 13.9469 0.736895 14.1983C0.436639 14.4497 0.213048 14.78 0.091498 15.1518C-0.0197661 15.515 -0.0297507 15.9017 0.0626156 16.2701C0.154982 16.6386 0.346212 16.9751 0.615784 17.2434L9.277 25.6098L7.17985 37.4901C7.10498 37.8822 7.14418 38.2875 7.29283 38.6581C7.44147 39.0287 7.69334 39.3492 8.01871 39.5817C8.33583 39.8078 8.70987 39.9413 9.09884 39.9671C9.4878 39.993 9.8763 39.9102 10.2207 39.7281L20.9581 34.1435L31.6535 39.749C31.9479 39.9146 32.2803 40.0011 32.6182 40C33.0625 40.0016 33.4957 39.8624 33.8555 39.6026C34.1809 39.3701 34.4328 39.0497 34.5814 38.679C34.7301 38.3084 34.7693 37.9031 34.6944 37.511L32.5973 25.6307L41.2585 17.2643C41.5613 17.0084 41.785 16.6722 41.9038 16.2945C42.0226 15.9169 42.0315 15.5134 41.9296 15.1309ZM29.0321 23.4973C28.7862 23.7345 28.6022 24.0282 28.4962 24.3527C28.3901 24.6771 28.3653 25.0226 28.4239 25.3588L29.9339 34.1226L22.0486 29.9394C21.7452 29.7783 21.4067 29.694 21.063 29.694C20.7192 29.694 20.3807 29.7783 20.0773 29.9394L12.192 34.1226L13.702 25.3588C13.7606 25.0226 13.7358 24.6771 13.6298 24.3527C13.5237 24.0282 13.3397 23.7345 13.0938 23.4973L6.80236 17.2225L15.6313 15.9466C15.9711 15.8995 16.294 15.7699 16.5719 15.5694C16.8498 15.3688 17.0741 15.1033 17.2252 14.7962L20.9581 6.82721L24.9007 14.8171C25.0518 15.1243 25.2761 15.3897 25.554 15.5903C25.8319 15.7908 26.1548 15.9204 26.4946 15.9675L35.3235 17.2434L29.0321 23.4973Z"
                  fill="#01486D"
                />
              </svg>

              <p>Bespoke approach</p>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.statMainContainer}>
        <p className={classes.heading}>Why choose Prime Bridge?</p>
        <div className={classes.statContainer}>
          <div className={`${classes.statItem} ${classes.first}`}>
            <div className={`${classes.stat} `}>
              <p>5+</p>
            </div>
            <div className={`${classes.info} ${classes.first}`}>
              <p>markets we operate in</p>
            </div>
          </div>
          <div className={`${classes.statItem} ${classes.statMiddleItem1}`}>
            <div className={classes.stat}>
              <p>150M+</p>
            </div>
            <div className={classes.info}>
              <p>
                in liquidity provided to hedge funds, UHNW individuals, and
                partners{" "}
              </p>
            </div>
          </div>
          <div className={`${classes.statItem} ${classes.statMiddleItem2}`}>
            <div className={classes.stat}>
              <p>70+</p>
            </div>
            <div className={classes.info}>
              <p>clients</p>
            </div>
          </div>
          <div className={`${classes.statItem} ${classes.custom} `}>
            <div
              className={`${classes.stat} ${classes.custom} ${classes.last}`}
            >
              <p>7B+</p>
            </div>
            <div
              className={`${classes.info} ${classes.custom} ${classes.last}`}
            >
              <p>
                dollars in trades executed monthly (approximate notional
                value, excluding swaps)
              </p>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageBody;
